import { useTheme } from '@mui/material/styles';

export const Base = ({ color, ...props }) => {
    const theme = useTheme();
    const finalColor = color || theme.palette.figma.white[30];

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="27" viewBox="0 0 16 27" fill="none">
            <path d="M6 13.5H16M0 0.5H6V26.5H0" stroke={finalColor} strokeOpacity="1" />
        </svg>
    );
};

export const Win01 = ({ color, ...props }) => {
    const theme = useTheme();
    const finalColor = color || theme.palette.figma.buttonOrange;

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="27" viewBox="0 0 16 27" fill="none">
            <path d="M6 13.5H16M0 0.5H6V26.5H0" stroke="white" strokeOpacity="0.3" />
            <path d="M0 0.5H6V13.5H16" stroke={finalColor} />
        </svg>
    );
};

export const Win02 = ({ color, ...props }) => {
    const theme = useTheme();
    const finalColor = color || theme.palette.figma.buttonOrange;

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="27" viewBox="0 0 16 27" fill="none">
            <path d="M6 13.5H16M0 0.5H6V26.5H0" stroke="white" strokeOpacity="0.3" />
            <path d="M0 26.5H6V13.5H16" stroke={finalColor} />
        </svg>
    );
};